import { useQuery } from '@tanstack/react-query';
import { Api as TestApi } from 'modules/test';

export interface TestOption {
  id: string;
  title: string;
}

/** Lightweight list of the org's tests, used to populate the analytics test filter. */
const useTestOptions = ({ orgId, enabled = true }: { orgId?: string; enabled?: boolean }) =>
  useQuery<TestOption[]>({
    queryKey: ['analytics', 'test-options', orgId],
    queryFn: async () => {
      const { data } = await TestApi.List({ perPage: 100 });
      return (data?.data?.items ?? []).map((t) => ({ id: t.id, title: t.title }));
    },
    enabled: !!orgId && enabled,
    staleTime: 5 * 60_000,
  });

export default useTestOptions;
